/**
 * URL path ↔ tab state 매핑 (Phase 1 — Router 도입 · S2 2-C 개정)
 *
 * App.jsx의 tab state(19종)와 URL path 일대일 매핑.
 * 새 탭 추가 시 TAB_ROUTES에 항목 추가만 하면 자동 동기화.
 * 2-C: "/"는 런처 전용(어떤 탭도 "/"에 매핑 금지) — dashboard는 /dashboard.
 *      미매핑 경로("/" 포함)의 tab 폴백은 dashboard 유지(런처 표시는 shell.view가 담당).
 */

export const TAB_ROUTES = [
  { tab: "dashboard", path: "/dashboard" }, // 2-C: "/"(런처 전용)에서 분리
  // C5: 역할 적응 근거 표면. 내부 탭 라우트 1개만 신설 —
  // 광고주 외부 진입은 기존 /client/{uuid} 그대로(ClientApp MemoryRouter 내부 이동).
  { tab: "evidence", path: "/evidence" },
  { tab: "campaign", path: "/campaign" },
  { tab: "adset", path: "/adset" },
  { tab: "creative_perf", path: "/creative" },
  { tab: "keyword", path: "/keyword" },
  { tab: "gallery", path: "/gallery" },
  { tab: "compare", path: "/compare" },
  { tab: "ga4", path: "/ga4" },
  { tab: "ga4_custom", path: "/ga4-custom" },
  { tab: "report", path: "/report" },
  { tab: "custom_dashboard", path: "/custom-dashboard" },
  { tab: "monitoring", path: "/monitoring" },
  { tab: "admin_dashboard", path: "/admin" },
  { tab: "tags", path: "/tags" },
  { tab: "goals", path: "/goals" },
  { tab: "media_mgmt", path: "/media" },
  { tab: "brand_editor", path: "/brand-settings" },
  { tab: "creative_report", path: "/creative-report" }, // D-2 임시 라우트
  { tab: "collection", path: "/collection" }, // S2 2-B 데이터 수집 허브
  { tab: "kit", path: "/kit" }, // Task 3 mpx 킷 데모(admin 전용 — canViewKitDemo 가드)
];

export function tabToPath(tab) {
  const route = TAB_ROUTES.find((r) => r.tab === tab);
  return route ? route.path : "/";
}

export function pathToTab(pathname) {
  // /client/{token} 등 비매핑 경로는 dashboard로 폴백
  const route = TAB_ROUTES.find((r) => r.path === pathname);
  return route ? route.tab : "dashboard";
}

// P0 판매 진입(docs/p0-sales-entry-spec.md §3) — 진입 라우트 판정(순수 함수, App 게이트 전용).
//   비로그인: "/"=landing(공개 상세페이지) · 그 외 전부 login(딥링크·/login·오타 경로, URL 보존)
//   로그인:   "/login"=home("/" replace) · 그 외 app(기존 Launcher/Home·탭)
//   /client/{uuid}는 main.jsx가 App 이전에 ClientApp으로 분기 — 이 helper에 흡수되지 않도록 "client"로 격리
//   (main.jsx CLIENT_TOKEN_RE 미러). 오타 경로를 공개 상세페이지로 취급하지 않는다.
const CLIENT_TOKEN_PATH_RE =
  /^\/client\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function resolveEntryRoute({ pathname, isAuthenticated } = {}) {
  const path = typeof pathname === "string" ? pathname : "/";
  if (CLIENT_TOKEN_PATH_RE.test(path)) return "client";
  if (!isAuthenticated) return path === "/" ? "landing" : "login";
  return path === "/login" ? "home" : "app";
}
